webpackJsonp([24686557463381],{

/***/ 1371:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"BoardingWardInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"locationId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"showBoardingSchedule","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"showPatientLocations","type":{"kind":"SCALAR","name":"Boolean","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-boarding-ward-input-da63e876d1c901936431.js